import React from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import './index.scss';
import { MIN_LEADERS_REQUIRED } from './constants';

// Pulls the counts it needs straight from the store (selected-survey count and
// the leader-gate scope), so the host doesn't have to subscribe to filter state
// just to feed this notice — a filter edit re-renders only this component, not
// the PDF-capture host. `variant` is the sole prop:
//  - 'selection' (default): the user simply hasn't picked enough leaders yet.
//  - 'self-feedback': enough leaders were selected, but too few have completed
//    their Self-feedback for aggregate results to be shown (leader-count gate).
const InsufficientSelectionNotice = ({ variant = 'selection', benchmarkFiltersAnalysis, leaderGateScope }) => {
    const surveyCount = benchmarkFiltersAnalysis && benchmarkFiltersAnalysis.surveys
        ? benchmarkFiltersAnalysis.surveys.length
        : 0;

    if (variant === 'self-feedback') {
        const scope = leaderGateScope || {};
        const minRequired = typeof scope.leaderGateMin === 'number' ? scope.leaderGateMin : MIN_LEADERS_REQUIRED;
        return (
            <div className='insufficient-selection'>
                <span className='insufficient-selection__icon'>
                    <ExclamationCircleOutlined />
                </span>
                <div className='insufficient-selection__body'>
                    <p className='insufficient-selection__title'>
                        Insufficient valid projects with Self-feedback completed.
                    </p>
                    <p className='insufficient-selection__subtitle'>
                        Only <strong>{scope.completedSelfCount}</strong> of the {surveyCount} selected projects
                        have Self-feedback completed. At least {minRequired} projects with completed
                        Self-feedback are required to display aggregate benchmark results, to protect
                        individual confidentiality. Add more using the Survey Name filter above, or check
                        back once additional Self-feedback is submitted.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className='insufficient-selection'>
            <span className='insufficient-selection__icon'>
                <ExclamationCircleOutlined />
            </span>
            <div className='insufficient-selection__body'>
                <p className='insufficient-selection__title'>
                    Select at least {MIN_LEADERS_REQUIRED} projects to view benchmark analysis results.
                </p>
                <p className='insufficient-selection__subtitle'>
                    You currently have <strong>{surveyCount}</strong> of {MIN_LEADERS_REQUIRED} selected. Aggregate
                    results are shown only for {MIN_LEADERS_REQUIRED} or more projects, to protect individual
                    confidentiality. Use the Survey Name filter above to add more.
                </p>
            </div>
        </div>
    );
};

export default InsufficientSelectionNotice;
